<template>
  <div class="c-calc-footer">
    <div class="c-calc-footer__inner">

      <img
        class="c-calc-footer__lightblulb"
        src="_resources/app/client/assets/images/lightbulp-grey.svg"
        alt="lightbulp icon"
      />

      <div class="logo">
        <a href="/"><img src="_resources/app/client/assets/images/we-logo.svg" alt="Wellington Electricity" title="Wellington Electricity" width="179" height="48" /></a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";

export default {
  created() {},
  components: {},
  mounted() {},
  methods: {},
  computed: {},
};
</script>
<style lang="scss">
.c-calc-footer {
  position: absolute;
  bottom: 0;
  left:0;
  width: 100%;
  background: #282828;
}
.c-calc-footer__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1024px;
  padding: 15px 90px;

  @media (max-width: 755px) {
    padding: 15px 5%;
  }
}
</style>
